import LeavesDetailsComp from '../components/LeaveDetails'

const EmployeeLeavePage = () => {
  return (
    <>   
    <LeavesDetailsComp/>
    </>
  )
}

export default EmployeeLeavePage